import { StandardHandles } from './StandardHandles';
import { TNodeProps } from '../types/node';
import { BaseNode } from './BaseNode';

export const HumanFormNode = (props: TNodeProps) => {
  return (
    <BaseNode {...props} className="min-w-80">
      <StandardHandles withReverseVerticals />
    </BaseNode>
  );
};

